import { get } from 'lodash';
import React from 'react';
import NotaryCommissions from 'routes/Profile/components/ProfileContent/NotaryCommissions';
import PortalProfileSaveButton from 'routes/Profile/components/ProfileContent/PortalProfileSaveButton';
import { FormActionButtonStyled } from 'routes/Profile/components/ProfileContent/styled';
import { NotaryDocumentType } from 'routes/Profile/components/ProfileContent/types';
import { IDocumentType } from 'types/user';
import IntlMessages from 'utils/IntlMessages';

import { IStepComponentProps } from './types';

const NotaryCommissionWizard: React.FC<IStepComponentProps> = ({
  userInfo,
  onClickNext,
  buttonLabel,
  isActive,
  saveButtonContainerClass,
  refetch,
  nextLoading,
}) => {
  const userDocuments = get(userInfo, 'documents', []);
  const commissions: IDocumentType[] = [];
  userDocuments.forEach((doc: IDocumentType) => {
    if (doc.type === NotaryDocumentType.COMMISSION) commissions.push(doc);
  });

  const onSubmit = () => {
    if (commissions?.length > 0) {
      onClickNext?.();
    }
  };
  return (
    <>
      <NotaryCommissions user={userInfo} refetchUserData={refetch} />
      <PortalProfileSaveButton containerClass={saveButtonContainerClass}>
        <FormActionButtonStyled
          isLoading={nextLoading}
          buttonType='primary'
          htmlType='button'
          className={`gx-mb-0 gx-mr-0 ${!isActive ? 'gx-d-none' : ''}`}
          onClick={() => {
            onSubmit();
          }}>
          {buttonLabel || <IntlMessages id='userProfile.saveProfile' />}
        </FormActionButtonStyled>
      </PortalProfileSaveButton>
    </>
  );
};

export default React.memo(NotaryCommissionWizard);
